var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 41.8337C9.4939 41.8337 0.166504 32.5062 0.166504 21.0003C0.166504 9.49439 9.4939 0.166992 20.9998 0.166992C32.5057 0.166992 41.8332 9.49439 41.8332 21.0003C41.8205 32.5009 32.5005 41.8209 20.9998 41.8337ZM4.33317 21.3587C4.43175 30.5278 11.9188 37.8951 21.0884 37.8462C30.2582 37.7966 37.6655 30.3493 37.6655 21.1795C37.6655 12.0097 30.2582 4.56235 21.0884 4.51283C11.9188 4.46378 4.43175 11.8311 4.33317 21.0003V21.3587ZM16.8332 30.3753V11.6253L29.3332 21.0003L16.8332 30.3753Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPlayIcon);
export default __webpack_public_path__ + "static/media/audio-play-icon.fdb5c352b1cc04af5117349719fee3eb.svg";
export { ForwardRef as ReactComponent };